import { BREAKPOINT_TABLET, BREAKPOINT_MOBILE } from '@/_consts/common'
declare module 'vue/types/vue' {
  interface Vue {
    $isTabletSize(): boolean
    $isMobileSize(): boolean
    $isSafari(): boolean
  }
}

export const isTabletSize = () => window.innerWidth <= BREAKPOINT_TABLET
export const isMobileSize = () => window.innerWidth <= BREAKPOINT_MOBILE
export const isSafari = () => /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
